<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <span class="title-h4 mr-r10">임계치 가이드 자원</span>
        <el-select  class="mr-r4" style="width: 100px;" v-model="objDefineId">
          <el-option v-for="(item, index) in objDefineList" :key="index" :label="item.objDefineName" :value="item.objDefineId"></el-option>
        </el-select>
        <el-popover placement="bottom" trigger="click" v-model="showEventPopover">
          <el-row class="title-bar" type="flex" justify="end">
            <w-header-search-button size="mini" @click="popoverShowSearchTool = !popoverShowSearchTool"></w-header-search-button>
          </el-row>
          <el-scrollbar class="bar-visible">
            <el-table-wrapper style="height: 400px; width: 400px;" ref="popoverTable" v-loading="loading" :columns="targetObjColumn" :data="setTargetObjList"  @condition-change="loadPopoverRscTable"
            row-class-name="c-pointer" :show-search-tool="popoverShowSearchTool" :show-custom-header="true" :pagination="true" @cell-click="selectTargetObjInfo"  remote :total="objTotal">
            </el-table-wrapper>
          </el-scrollbar>
          <el-input class="c-pointer mr-r4" @click.native="clickInputButton" style="width:200px;" slot="reference" v-model="selectedEventHistLabel" placeholder="장비 선택" readonly>
            <i slot="suffix" v-if="selectedEventHistLabel !== null"
              class="el-input__icon el-icon-circle-close el-input__clear"
              @click="clickClearable"></i>
          </el-input>
        </el-popover>
        <el-button size="mini" @click="showPeriodPopup" class="mr-r4">주기 설정</el-button>
        <el-button size="mini" :disabled="isSetInterval" @click="showEditTargetPopup" class="mr-r4">자원 설정</el-button>
        <el-button size="mini" :disabled="!isAbleDeleteRsc" class="mr-r4" @click="deleteGuideRsc">자원 삭제</el-button>
        <span class="text-em  mr-l4">
          {{isSetInterval ? '임계치 가이드 수행 스케줄이 설정되어 있지 않습니다.' : `${scheduleContent} (${nextSchedule})`}}
        </span>
      </div>
      <w-header-search-button size="mini" @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </el-row>
    <div>
      <el-table-wrapper :data="thresholdGuideData" :columns="thresholdTableColumn" ref="thresholdTable" @selection-change="changeHandleSelection"
        remote :total="total" :pagination="true" style="width:100%;" :show-search-tool="showSearchTool" :show-custom-header="true" @condition-change="loadThresholdInfo">
      </el-table-wrapper>
    </div>
    <w-edit-guide-setting-popup ref="editPopup" @reload="reloadTargetInfo"/>
    <w-period-setting-popup ref="periodPopup" @reload="loadBasicinfoForGuide" :period-info="periodSettingInfo"/>
  </div>
</template>

<script>
import { isNil, isEmpty, isEqual } from 'lodash';
import moment from 'moment';
import { WEEK, TIME, MINUTE } from '@/constants/date';
import msgUtil from '@/utils/message';
import { getValueAfterCheckEmpty } from '@/utils/string';
import EventGuideSettingsAPI from '@/api/settings/common/event-guide-settings';
import WEditGuideSettingPopup from './popup/EditGuideSettingPopup';
import WPeriodSettingPopup from './popup/PeriodSettingPopup';

export default {
  name: 'WGuideSettingView',
  components: {
    WEditGuideSettingPopup,
    WPeriodSettingPopup,
  },
  props: {
    activeTab: {
      type: String,
    },
  },
  data() {
    return {
      selectedEventHistLabel: null,
      showEventPopover: false,
      total: 0,
      targetObjParams: {},
      thresholdGuideData: [],
      selectedList: [],
      popoverShowSearchTool: false,
      showSearchTool: false,
      guideCycleInfo: {},
      periodSettingInfo: {},
      scheduleContent: '',
      nextSchedule: '',
      isSetInterval: true,
      setTargetObjList: [],
      objTotal: 0,
      objDefineId: null,
      loading: false,
      objDefineList: [],
      targetObjColumn: [
        {
          prop: 'objDefineName',
          label: '관리 구분',
          remoteProp: 'obj.obj_define_name',
          sortable: true,
          searchable: true,
          width: 100,
        },
        {
          prop: 'objName',
          label: '장비명',
          remoteProp: 'obj.obj_name',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'ipaddress',
          label: 'IP 주소',
          sortable: true,
        },
      ],
      thresholdTableColumn: [
        {
          type: 'selection',
        },
        {
          prop: 'objName',
          label: '장비',
          headerAlign: 'center',
          remoteProp: 'o.obj_name',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'ipaddress',
          label: 'IP 주소',
          headerAlign: 'center',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'managetypeName',
          label: '관리 구분',
          headerAlign: 'center',
          remoteProp: 'm.managetype_name',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'rsctypeName',
          label: '자원 구분',
          headerAlign: 'center',
          remoteProp: 'rt.rsctype_name',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'rscName',
          label: '자원',
          headerAlign: 'center',
          remoteProp: 'r.rsc_name',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'rscKey',
          label: '자원키',
          headerAlign: 'center',
          remoteProp: 'ork.rsc_key',
          sortable: true,
          searchable: true,
        },
      ],
    };
  },
  computed: {
    isAbleDeleteRsc() {
      return !isEmpty(this.selectedList) && this.selectedList.length > 0;
    },
  },
  watch: {
    objDefineId: {
      handler(value) {
        if (!isNil(value)) {
          this.showEventPopover = false;
          this.targetObjParams.objId = null;
          if (value === 'all') {
            this.targetObjParams.objDefineId = null;
          } else {
            this.targetObjParams.objDefineId = value;
          }
          this.loadThresholdInfo();
        }
      },
      immediate: true,
    },
  },
  methods: {
    loadData() {
      if (this.activeTab === 'WGuideSettingView') {
        this.objDefineId = null;
        this.loadGuideTargetData();
        this.loadBasicinfoForGuide();
      }
    },
    /**
     * 임계치 가이드 자원 설정 팝업을 연다.
     * @author Ju
     */
    showEditTargetPopup() {
      this.$refs.editPopup.open();
    },
    showPeriodPopup() {
      this.periodSettingInfo = this.guideCycleInfo;
      this.$refs.periodPopup.open();
    },
    /**
     * 임계치 가이드 자원 목록을 조회한다.
     * @author yelim
     * @return {[type]}
     */
    loadThresholdInfo() {
      this.$nextTick(() => {
        const tableParams = this.$refs.thresholdTable.getParameter();
        const params = {
          ...this.targetObjParams,
          ...tableParams,
        };
        EventGuideSettingsAPI.getTargetThresGuide(params).then((response) => {
          if (response.data.success) {
            this.thresholdGuideData = response.data.data;
            this.total = response.data.total;
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '임계치 가이드 자원 목록', false));
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '임계치 가이드 자원 목록', false));
          throw new Error(e);
        });
      });
    },
    /**
     * 임계치 가이드를 수행하는 주기가 설정되어있는지 확인한다.
     * @author yelim
     */
    loadBasicinfoForGuide() {
      EventGuideSettingsAPI.getBasicinfoSetForGuide().then((response) => {
        if (response.data.success) {
          const result = response.data.data;
          const guideCycleInfo = {};
          result.forEach((item) => {
            guideCycleInfo[item.basicinfoSubid] = item.guideInfoValue;
          });
          this.guideCycleInfo = guideCycleInfo;
          const scheduleInfo = this.setScheduleContent();
          this.scheduleContent = scheduleInfo.scheduleContent;
          this.nextSchedule = scheduleInfo.nextExecuteInfo;
          if (!isEmpty(this.guideCycleInfo)) {
            this.isSetInterval = !(this.guideCycleInfo.SCHEDULE_APPLY_FLAG !== 'N');
          }
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '임계치 가이드 주기 설정 정보', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '임계치 가이드 주기 설정 정보', false));
        throw new Error(e);
      });
    },
    reloadTargetInfo() {
      this.loadThresholdInfo();
      this.loadGuideTargetData();
      this.loadPopoverRscTable();
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * 대상에 설정된 임계치 가이드 자원을 삭제한다.
     * @author yelim
     */
    deleteGuideRsc() {
      // 삭제 대상으로 선택된 리스트
      const deleteList = this.selectedList;
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
        EventGuideSettingsAPI.deleteThresholdRsc(deleteList).then((response) => {
          if (response.data.success) {
            // this.objDefineId = this.objDefineId;
            this.targetObjParams.objDefineId = (this.objDefineId === 'all') ? null : this.objDefineId;
            this.reloadTargetInfo();
            this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '임계치 가이드 자원', true));
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '임계치 가이드 자원', false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '임계치 가이드 자원', false));
        });
      });
    },
    /**
     * 그리드에서 선택된 항목을 관리한다.
     * @author yelim
     * @param  {[type]} rows [description]
     * @return {[type]}      [description]
     */
    changeHandleSelection(rows) {
      this.selectedList = rows;
    },
    /**
     * 주기가 설정되어 있는 경우 주기 정보를 가공한다.
     * @author yelim
     */
    setScheduleContent() {
      const scheduleInfo = {
        scheduleContent: null,
        nextExecuteInfo: null,
      };
      if (!isNil(this.guideCycleInfo)) {
        if (this.guideCycleInfo.SCHEDULE_APPLY_FLAG === 'Y') {
          const scheduleData = this.guideCycleInfo;
          const schedulePeriod = scheduleData.SCHEDULE_PERIOD;
          const scheduleHour = Number(scheduleData.SCHEDULE_HOUR);
          const scheduleMinute = Number(scheduleData.SCHEDULE_MINUTE);
          const nextScheduleInfo = new Date();
          const curYear = nextScheduleInfo.getFullYear();
          const curMonth = nextScheduleInfo.getMonth();
          const curDay = nextScheduleInfo.getDate();
          const curWeekOfDay = nextScheduleInfo.getDay();

          const curHour = TIME[scheduleHour];
          const curMin = MINUTE[scheduleMinute];
          if (isEqual(schedulePeriod, 'D')) {
            scheduleInfo.scheduleContent = `매일 ${curHour.label}:${curMin.label}`;
            const changeNextSchedule = moment([curYear, curMonth, curDay + 1]).hour(TIME[scheduleHour].time).minutes(MINUTE[scheduleMinute].minute).format('YYYY-MM-DD HH:mm');
            scheduleInfo.nextExecuteInfo = `다음 수행 일시: ${changeNextSchedule}마다 수행`;
          } else if (isEqual(schedulePeriod, 'W')) {
            let nextDayOfWeek;
            const setDayOfweek = scheduleData.SCHEDULE_INTERVAL_DATE - 1;
            const dateText = `${WEEK[scheduleData.SCHEDULE_INTERVAL_DATE - 1].label}`;
            scheduleInfo.scheduleContent = `매주 ${dateText} ${TIME[scheduleHour].label}:${MINUTE[scheduleMinute].label}마다 수행`;
            if (setDayOfweek >= curWeekOfDay) {
              nextDayOfWeek = setDayOfweek;
            } else {
              nextDayOfWeek = setDayOfweek + 7;
            }
            const changeNextSchedule = moment([curYear, curMonth, curDay]).weekday(nextDayOfWeek).hour(TIME[scheduleHour].time).minutes(MINUTE[scheduleMinute].minute);
            scheduleInfo.nextExecuteInfo = `다음 수행 일시: ${changeNextSchedule.format('YYYY-MM-DD HH:mm')}`;
          } else if (isEqual(schedulePeriod, 'M')) {
            const rawDate = scheduleData.SCHEDULE_INTERVAL_DATE === 'E' ? 31 : scheduleData.SCHEDULE_INTERVAL_DATE;
            const dateText = `${isEqual(rawDate, 'E') ? '마지막' : rawDate}일`;
            scheduleInfo.scheduleContent = `매월 ${dateText} ${TIME[scheduleHour].label}:${MINUTE[scheduleMinute].label}마다 수행`;
            const changeNext = moment([curYear, curMonth, rawDate]).hour(TIME[scheduleHour].time).minutes(MINUTE[scheduleMinute].minute);
            changeNext.add(1, 'months');
            scheduleInfo.nextExecuteInfo = `다음 수행 일시: ${changeNext.format('YYYY-MM-DD HH:mm')}`;
          }
        }
      }
      return scheduleInfo;
    },
    /**
     * 조회할 obj를 선택한다.
     * @author yelim
     * @param  {[type]} row [description]
     */
    selectTargetObjInfo(row) {
      this.showEventPopover = false;
      this.targetObjParams.objId = row.objId;
      this.targetObjParams.objDefineId = row.objDefineId;
      this.selectedEventHistLabel = `[${getValueAfterCheckEmpty(row.objName)}] ${getValueAfterCheckEmpty(row.ipaddress)}`;
      this.loadThresholdInfo();
    },
    clickClearable() {
      if (!isNil(this.selectedEventHistLabel)) {
        this.targetObjParams.objId = null;
        this.targetObjParams.objDefineId = (this.objDefineId === 'all') ? null : this.objDefineId;
        this.selectedEventHistLabel = null;
        this.loadThresholdInfo();
      }
    },
    loadPopoverRscTable() {
      const tableParams = this.$refs.popoverTable.getParameter();
      const params = {
        objDefineId: this.targetObjParams.objDefineId,
        ...tableParams,
      };
      EventGuideSettingsAPI.getThresholdTargetObjInfo(params).then((response) => {
        if (response.data.success) {
          this.setTargetObjList = response.data.data;
          this.objTotal = response.data.total;
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '이벤트 예측 자원 목록', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '이벤트 예측 자원 목록', false));
        throw new Error(e);
      });
    },
    loadGuideTargetData() {
      EventGuideSettingsAPI.getThresholdTargetObjDefine().then((response) => {
        if (response.data.success) {
          const objDefineList = [];
          const result = response.data.data;
          objDefineList.push({ objDefineName: '전체', objDefineId: 'all' });
          this.objDefineList = objDefineList.concat(result);
          this.objDefineId = this.objDefineList[0].objDefineId;
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '임계치 가이드 자원 관리 구분 목록', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '임계치 가이드 자원 관리 구분 목록', false));
        throw new Error(e);
      });
    },
    clickInputButton() {
      this.loadPopoverRscTable();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/EventPredictSetting/GuideSetting/GuideSettingView.vue